import React from "react";
import SignInComponent from "../../components/ParentAuthentication/SignInComponent";

const SignInPage = () => {
  return (
    <div>
      <SignInComponent />
    </div>
  );
};

export default SignInPage;
